function textTemplate(template, data) {
  return template.replace(
    /{(\w*)}/g, // or /{(\w*)}/g for "{this} instead of %this%"
    (m, key) => data[key] || ''
  )
}

export default textTemplate
